export default "__VITE_ASSET__CRMm8ufT__"